import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import SocialApi from '../api/social';
import { healthCounts } from '../components/connections/health';

// Fired by the Connections page whenever it reloads, e.g. after a reconnect
export const CONNECTIONS_CHANGED = 'connections-changed';

/**
 * Number of connections not working, refreshed on every page change and on CONNECTIONS_CHANGED
 */
export default function useConnectionIssues(enabled) {
  const { pathname } = useLocation();
  const [count, setCount] = useState(0);
  const [changes, setChanges] = useState(0);

  useEffect(() => {
    const changed = () => setChanges((value) => value + 1);
    window.addEventListener(CONNECTIONS_CHANGED, changed);
    return () => window.removeEventListener(CONNECTIONS_CHANGED, changed);
  }, []);

  useEffect(() => {
    if (!enabled) return undefined;
    let current = true;
    SocialApi.sites()
      .then((data) => current && setCount(healthCounts(data.results.flatMap((site) => site.connections)).error))
      .catch(() => {});
    return () => {
      current = false;
    };
  }, [enabled, pathname, changes]);

  return count;
}
